"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const React = require("react");
const react_1 = require("react");
const CollapsibleContext_1 = require("../../../../../../contexts/CollapsibleContext");
const Icon_1 = require("../../../../atoms/Icon");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "BaseTitle");
/**
 *  Renders basic Title component.
 *  This should never be used directly. Each higher level component should expose a
 *  ComponentHeader wrapper
 */
const Title = ({ children, className = "", size = 2, position = "left", decorated = false, collapseToggle = true }) => {
    const { onToggleCollapse, isCollapsed } = (0, react_1.useContext)(CollapsibleContext_1.CollapsibleContext);
    const isCollapsible = collapseToggle && typeof onToggleCollapse === "function";
    const H = () => {
        switch (size) {
            case 1:
                return React.createElement("h1", null, children);
            case 2:
                return React.createElement("h2", null, children);
            case 3:
                return React.createElement("h3", null, children);
            case 4:
                return React.createElement("h4", null, children);
            case 5:
                return React.createElement("h5", null, children);
            case 6:
                return React.createElement("h6", null, children);
        }
    };
    return (React.createElement("div", { "data-test": "title", className: css("", `-${position}`, {
            "-collapsible": isCollapsible,
            "-isCollapsed": isCollapsed,
            className
        }), onClick: () => isCollapsible && onToggleCollapse() },
        isCollapsible && (React.createElement(Icon_1.Icon, { className: css("chevron"), name: "chevron-right" })),
        React.createElement(H, null, children),
        decorated && React.createElement("hr", null)));
};
exports.Title = Title;
//# sourceMappingURL=index.js.map